<template>
  <section id="storitve">
    <div id="storitve-anchor" class="scroll-to-anchor"></div>
    <div class="bgs">
      <div class="bg bg1"></div>
      <div class="bg bg2"></div>
      <div class="bg bg3"></div>
      <div class="bg bg4"></div>
      <div class="bg bg5"></div>
      <div class="bg bg6"></div>
    </div>

    <b-modal id="modal-1" :title="openedService.title ? openedService.title.toUpperCase() :  ''" centered v-model="modalOpened" size="lg" hide-footer>
      <div class="openedService">
        <div class="inner" :class="openedService.id">
          <div
            class="opis"
            ref="desc"
            v-html="openedService.description"
          ></div>
              <div class="all-images">
                <div
                  :class="['images-' + s.id, 'images']"
                  v-for="s in Services"
                  :key="s.id"
                  v-if="s.id == openedService.id"
                >
                  <a
                    v-for="n in openedService.photos"
                    :href="
                    '/static/storitve/details/' +
                      openedService.id +
                      '/bigger/' +
                      n +
                      '.jpg'
                  "
                    :key="n"
                    :data-title="''"
                    :data-mediabox="'reference-' + openedService.id"
                    class="image"
                  >
                    <img
                      :src="
                        '/static/storitve/details/' +
                        openedService.id +
                        '/' +
                        n +
                        '.jpg'
                      "
                      :alt="openedService.title"
                      class="single-image"
                    />

                  </a>
                </div>
              </div>
        </div>
      </div>
    </b-modal>

    <div class="container boxes">
      <Service
        v-for="(service, index) in Services"
        :data="service"
        :key="service.id"
        :index="index"
        v-on:open="open"
      ></Service>
    </div>
  </section>
</template>

<script>
import Service from "./Service.vue";
import Thumb from "./Thumb.vue";

require("../../scripts/Lightbox.js");

// TODO: Move that to AJAX call
import ServicesData from "./ServicesData.js";

export default {
  components: {
    Service,
    Thumb
  },

  data() {
    return {
      modalOpened: false,
      Services: ServicesData,
      opened: false,
      openedService: {},
      activeId: null,
      animated: false,
      tempService: {}
    };
  },

  methods: {
    open(serviceID) {
      var serviceToOpen = this.findByID(serviceID);

      if (serviceToOpen.opened) return false;

      this.openedService = serviceToOpen;
      this.modalOpened = true;
      // PDF cache bust
      serviceToOpen.description = serviceToOpen.description.replace(
        "currenttime",
        Date.now()
      );

      this.$nextTick(() => {
        const images = document.querySelector(".images-" + this.openedService.id);
        //Init lightbox
        WAMediaBox.bindAll(images);
      })


    },

    findByID(id) {
      // Returns single Service object
      var found;
      this.Services.forEach(function(service) {
        if (service.id == id) found = service;
      }, this);
      return found;
    },
  } // End methods
};
</script>

<style lang="scss">

.openedService p {
  letter-spacing: 0;
  font-weight: 400;
}

.openedService .images {
  display:flex;
  gap:10px;
  flex-wrap:wrap;
}

.openedService .image {
  width:100px;
  height:100px;
  display:inline-block;

  img {
    width: 100%;
    height:100%;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/Services.vue